import _slicedToArray from "/runner/_work/developers/developers/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import "core-js/modules/es.object.from-entries.js";
import { getLocaleFallbackLink } from "../../util/translator";
import React, { memo, useCallback, useMemo, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { useMainContext } from "../main-context";
import { ALL_LOCALE, LOCALE_DISPLAY_NAME_MAP, UPCOMING_LOCALE, SELECT_POSITIONS } from "./constants";
import LanguagesMenu from "./languages-menu";
import CaretDown from "./caret-down";
import Globe from "./globe";
import { Container, Prefix, Suffix, Text, Button } from "./language-switcher.styles";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var LanguageSwitcher = function LanguageSwitcher(_ref) {
  var pageLocales = _ref.pageLocales,
    onLanguageSwitcherOptionClick = _ref.onLanguageSwitcherOptionClick,
    position = _ref.position;
  var triggerRef = useRef();
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  var _useMainContext = useMainContext(),
    locale = _useMainContext.locale;
  var createOptions = useCallback(function (localesMap) {
    return Object.keys(localesMap).map(function (supportedLocale) {
      return {
        locale: supportedLocale,
        label: localesMap[supportedLocale],
        href: (pageLocales.find(function (pageLocale) {
          return pageLocale.title === supportedLocale;
        }) || {}).href || getLocaleFallbackLink(supportedLocale)
      };
    });
  }, [pageLocales]);
  var options = useMemo(function () {
    var availableLocales = pageLocales.map(function (pageLocale) {
      return pageLocale.title;
    });
    var localesMap = Object.fromEntries(Object.entries(LOCALE_DISPLAY_NAME_MAP).filter(function (_ref2) {
      var _ref3 = _slicedToArray(_ref2, 1),
        key = _ref3[0];
      return availableLocales.includes(key);
    }));
    var upcomingLocaleKey = Object.keys(UPCOMING_LOCALE).find(function (upcomingLocale) {
      return upcomingLocale === locale;
    });
    if (upcomingLocaleKey) {
      localesMap[upcomingLocaleKey] = UPCOMING_LOCALE[upcomingLocaleKey];
    }
    return createOptions(localesMap);
  }, [createOptions, locale, pageLocales]);
  var handleClick = useCallback(function (event) {
    event.stopPropagation();
    setIsOpen(function (prevIsOpen) {
      return !prevIsOpen;
    });
  }, []);
  return /*#__PURE__*/_jsxs(Container, {
    children: [/*#__PURE__*/_jsx(LanguagesMenu, {
      options: options,
      onLanguageSwitcherOptionClick: onLanguageSwitcherOptionClick,
      isOpen: isOpen,
      setIsOpen: setIsOpen,
      triggerRef: triggerRef,
      position: position
    }), /*#__PURE__*/_jsxs(Button, {
      onClick: handleClick,
      ref: triggerRef,
      children: [/*#__PURE__*/_jsx(Prefix, {
        children: /*#__PURE__*/_jsx(Globe, {})
      }), /*#__PURE__*/_jsx(Text, {
        children: ALL_LOCALE[locale]
      }), /*#__PURE__*/_jsx(Suffix, {
        children: /*#__PURE__*/_jsx(CaretDown, {})
      })]
    })]
  });
};
LanguageSwitcher.displayName = 'LanguageSwitcher';
LanguageSwitcher.propTypes = {
  /**
   * Available languages for the current page. Each item in
   * this array will be rendered as a link option containing its href.
   *
   * Obs: `fr` and `de` are upcoming locales, so are just displayed in
   * options if it is the current location.
   */
  pageLocales: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.oneOf(Object.keys(ALL_LOCALE)),
    href: PropTypes.string
  })).isRequired,
  /** Set the orietation of the select */
  position: PropTypes.oneOf(Object.values(SELECT_POSITIONS)),
  /** Callback function for the select language action */
  onLanguageSwitcherOptionClick: PropTypes.func.isRequired
};
LanguageSwitcher.defaultProps = {
  position: SELECT_POSITIONS.TOP
};
export default /*#__PURE__*/memo(LanguageSwitcher);